// Mock data for audit logs
import { AuditLog } from './types';

export const mockAuditLogs: AuditLog[] = [
  {
    id: 'log-1',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'LOGIN',
    resource: 'System',
    resourceId: null,
    details: 'Successful login',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-24T08:30:00'
  },
  {
    id: 'log-2',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'UPDATE',
    resource: 'SystemConfiguration',
    resourceId: 'system-config-1',
    details: 'Updated learning phase progression rules',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-24T08:45:00'
  },
  {
    id: 'log-3',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'CONCURRENT_ACCESS',
    resource: 'User',
    resourceId: 'teacher-1',
    details: 'Started concurrent access session as Teacher (Read-Only Mode)',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-24T09:15:00'
  },
  {
    id: 'log-4',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'CONCURRENT_ACCESS',
    resource: 'User',
    resourceId: 'teacher-1',
    details: 'Ended concurrent access session',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-24T09:25:00'
  },
  {
    id: 'log-5',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'UPLOAD',
    resource: 'Questions',
    resourceId: null,
    details: 'Uploaded questions CSV: questions_batch_k2_20250522.csv',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-22T14:30:00'
  },
  {
    id: 'log-6',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'UPLOAD',
    resource: 'Game',
    resourceId: 'game-12',
    details: 'Uploaded new game: Math Blaster',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-21T11:20:00'
  },
  {
    id: 'log-7',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'UPDATE',
    resource: 'School',
    resourceId: 'school-3',
    details: 'Updated school settings',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-20T15:45:00'
  },
  {
    id: 'log-8',
    userId: 'user-1',
    userName: 'John Admin',
    userRole: 'SuperAdmin',
    action: 'MANUAL_IMPORT',
    resource: 'CSV',
    resourceId: 'import-4',
    details: 'Manually triggered Standards Map import',
    ipAddress: '192.168.1.100',
    timestamp: '2025-05-20T10:10:00'
  },
  {
    id: 'log-9',
    userId: 'user-2',
    userName: 'Sarah Manager',
    userRole: 'SchoolAdmin',
    action: 'LOGIN',
    resource: 'System',
    resourceId: null,
    details: 'Successful login',
    ipAddress: '192.168.1.101',
    timestamp: '2025-05-24T09:00:00'
  },
  {
    id: 'log-10',
    userId: 'user-2',
    userName: 'Sarah Manager',
    userRole: 'SchoolAdmin',
    action: 'UPDATE',
    resource: 'School',
    resourceId: 'school-1',
    details: 'Updated school curriculum priorities',
    ipAddress: '192.168.1.101',
    timestamp: '2025-05-24T09:30:00'
  }
];
